<template>
  <div>
    <h3 class="font-semibold my-2">Select a financial institution</h3>
    <a-select
      show-search
      placeholder="Choose a financial institution"
      option-filter-prop="children"
      style="width: 400px;"
      v-model="selectedInstitutionId"
    >
      <a-select-option
        v-for="institution in financialInstitutions"
        :key="institution.id"
        :value="institution.id"
      >
        {{ institution.name }}
      </a-select-option>
    </a-select>
    <a-button
      class="ml-2"
      type="primary"
      @click="addReport()"
      :disabled="!selectedInstitutionId"
    >
      Add report
    </a-button>
    <fi-reports-list
      v-if="selectedInstitutionId"
      ref="reportsList"
      :institutionId="selectedInstitutionId"
      @showReport="showReport($event)"
      @editReport="editReport($event)"
      @deleteReport="deleteReport($event)"
    />
    <a-drawer
      title="Add Monthly Report"
      width="600"
      placement="right"
      :visible="showAddReportDrawer"
      @close="onAddReportDrawerClosed()"
    >
      <add-fi-monthly-report
        :institution="selectedInstitution"
        @reportSaved="onReportAdded($event)"
        @cancelButtonClicked="showAddReportDrawer = false"
      />
    </a-drawer>
    <a-drawer
      :title="reportDrawerTitle"
      width="600"
      placement="right"
      :visible="showReportDrawer"
      @close="onReportDrawerClosed()"
    >
      <fi-monthly-report v-if="selectedReport" :report="selectedReport" />
    </a-drawer>
    <a-drawer
      :title="reportDrawerTitle"
      width="600"
      placement="right"
      :visible="showEditReportDrawer"
      @close="onEditReportDrawerClosed()"
    >
      <edit-fi-monthly-report
        v-if="selectedReport"
        :report="selectedReport"
        @reportSaved="onReportUpdated($event)"
        @cancelButtonClicked="showEditReportDrawer = false"
      />
    </a-drawer>
  </div>
</template>

<script>
import gql from 'graphql-tag'
import FiReportsList from '../components/FIReporting/FIReportsList.vue'
import AddFiMonthlyReport from '../components/FIReporting/AddFIMonthlyReport.vue'
import EditFiMonthlyReport from '../components/FIReporting/EditFIMonthlyReport.vue'
import FiMonthlyReport from '../components/FIReporting/FIMonthlyReport.vue'

export default {
  components: {
    AddFiMonthlyReport,
    EditFiMonthlyReport,
    FiMonthlyReport,
    FiReportsList,
  },
  apollo: {
    financialInstitutions: {
      client: 'kpis',
      query: gql`
        query {
          financialInstitutions {
            id
            name
            isin
            currency
          }
        }
      `,
    },
  },
  data() {
    return {
      financialInstitutions: [],
      selectedInstitutionId: null,
      selectedReport: null,
      showAddReportDrawer: false,
      showEditReportDrawer: false,
      showReportDrawer: false,
    }
  },
  computed: {
    selectedInstitution() {
      return this.financialInstitutions.find(
        (i) => i.id == this.selectedInstitutionId,
      )
    },
    reportDrawerTitle() {
      if (!this.selectedReport) {
        return ''
      }
      if (!this.selectedInstitution) {
        return ''
      }
      return `${this.selectedInstitution.name} - ${this.selectedReport.year}/${this.selectedReport.month}`
    },
  },
  methods: {
    addReport() {
      this.showAddReportDrawer = true
    },
    editReport(report) {
      this.selectedReport = report
      this.showEditReportDrawer = true
    },
    showReport(report) {
      this.selectedReport = report
      this.showReportDrawer = true
    },
    async deleteReport({ institutionId, year, month }) {
      await this.$apollo.mutate({
        mutation: gql`
          mutation($input: DeleteFIMonthlyReportInput) {
            deleteFIMonthlyReport(input: $input) {
              reportId
            }
          }
        `,
        variables: {
          input: {
            institutionId,
            year,
            month,
          },
        },
      })
      this.$refs.reportsList.reloadReports()
    },
    onReportDrawerClosed() {
      this.showReportDrawer = false
    },
    onAddReportDrawerClosed() {
      this.showAddReportDrawer = false
    },
    onEditReportDrawerClosed() {
      this.showEditReportDrawer = false
    },
    onReportAdded() {
      this.showAddReportDrawer = false
      this.$refs.reportsList.reloadReports()
    },
    onReportUpdated() {
      this.showEditReportDrawer = false
      this.selectedReport = null
      this.$refs.reportsList.reloadReports()
    },
  },
}
</script>

<style></style>
